module.exports = __webpack_public_path__ + "img/bigleft2.da6b0057.svg";